import React, { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import '../BranchMangement/BranchListContainer.css'
import { Container } from 'reactstrap'
import AllMembersList from "./AllMembersList"
import CreateUser from "./CreateUser"
import MembersListHeader from "./MemberListHeader"
import RestrictedSection from "../../Components/RestrictedSection"
import { usePresetFilters } from '../../Filters/presetFilters'

import withApolloClient from '../../withApolloClient'

// Editable, visible default: the list opens showing active members; the user
// can flip it to false or drop it entirely from the Advanced Filters popover/chips.
const USER_IS_ACTIVE_PRESET = [
    { fieldName: "user_is_active", filterType: "equal", filterValues: "true", editable: true, visible: true },
]

class MembersListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorMessage: null,
            showEdit: "",
            input: {},
            searchTerm: "",
            openModal: "",
            selectedMembers: [],
            showView: "membersList",
            refetchMembers: false,
            filterValues: {},
        }
    }
    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        let currentState = this.state
        currentState[name] = value
        this.setState({ ...currentState })
    }


    render() {
        return (
            <RestrictedSection requiredPermission="view_member">
                <Container fluid className="bos-listing-container">
                    <MembersListHeader
                        activeTab="members"
                        currentUser={this.props.currentUser}
                        filterValues={this.state.filterValues}
                        setFilterValues={(filterValues) => this.setState({ filterValues })}
                        location={this.props.location} history={this.props.navigate}
                        defaultFilters={this.state.filterValues}
                        showView={this.state.showView}
                        changeView={(showView) => this.setState({ showView })}
                        selectedMembers={this.state.selectedMembers}
                        resetSelectedMembers={() => this.setState({ selectedMembers: [] })}
                        refetchQuery={() => this.setState({ refetchMembers: !this.state.refetchMembers })}
                        presets={this.props.presets}
                        setPresets={this.props.setPresets}
                        defaultPresets={this.props.defaultPresets}
                    />
                    {this.state.showView === "membersList" ?
                        <AllMembersList
                            key={String(this.state.refetchMembers)}
                            searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                            selectedMembers={this.state.selectedMembers}
                            setSelectedMembers={(selectedMembers) => this.setState({ selectedMembers })}
                            presets={this.props.presets}
                        />
                        : <CreateUser memberDetails={""} />}
                </Container>
            </RestrictedSection>
        )
    }
}

const MembersListContainerWithApollo = withApolloClient(MembersListContainer)

// Preset state is owned here so both the header (popover + chips) and the list
// (query variables) share one source of truth.
export default function MembersListContainerWithFilters(props) {
    const [presets, setPresets, defaultPresets] = usePresetFilters(USER_IS_ACTIVE_PRESET)
    return <MembersListContainerWithApollo {...props} presets={presets} setPresets={setPresets} defaultPresets={defaultPresets} />
}
